import { forwardRef, type Ref, type SVGProps } from "react";
const IconTextUnderlinedOutlineSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M16 26a9.27 9.27 0 0 0 9-9.5V2h-2v14.5a7.27 7.27 0 0 1-7 7.5 7.27 7.27 0 0 1-7-7.5V2H7v14.5a9.27 9.27 0 0 0 9 9.5M4 28h24v2H4z" /></svg>;
const ForwardRef = forwardRef(IconTextUnderlinedOutlineSVG);
ForwardRef.displayName = "IconTextUnderlinedOutline";
export { ForwardRef as IconTextUnderlinedOutline };